window.axios = require('axios');

import Vue from 'vue'
import App from './App.vue'
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false
Vue.component('app-component', App);

new Vue({
  el: '#app',
  router,
});
